<template>
  <span
    :style="{'--background': color}"
    class="bg-background text-light rounded px-2 py-1 inline-block"
  >
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'var(--dark-lightest)',
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/server/components/shared/Label.vue